import React from 'react';
import {
  MarketAccessory,
  MarketActivityIndicatorBar,
  MarketButton,
  MarketHeader,
} from '@market/react';
import makeStyles from '@mui/styles/makeStyles';
import { useTranslation } from 'react-i18next';

export const PROGRESS_BAR_TEST_ID = 'progress-bar';
export const BACK_BUTTON_TEST_ID = 'back-button';
export const DONE_BUTTON_TEST_ID = 'done-button';

const useStyles = makeStyles((theme) => ({
  header: {
    marginBottom: 'var(--core-metrics-spacing-300)',
    backgroundColor: 'white',
    position: 'sticky',
    top: 0,
    zIndex: 1000,
  },
  buttonBar: {
    height: '80px',
  },
  navButton: {
    margin: theme.spacing(2, 3),
  },
  progressBar: {
    position: 'relative',
    height: 'var(--core-metrics-spacing-100)',
    left: '-2px',
    width: 'calc(100% + 4px)',
  },
}));

const DashboardModeHeader = ({
  progress = 1,
  showBackButton = false,
  showDoneButton = false,
  backButtonAction = () => {},
  doneButtonAction = () => {},
}) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div className={classes.header}>
      <div className={classes.buttonBar}>
        <MarketHeader compact>
          {showBackButton ? (
            <MarketButton
              rank="secondary"
              slot="navigation"
              className={classes.navButton}
              onClick={backButtonAction}
              data-testid={BACK_BUTTON_TEST_ID}
            >
              <MarketAccessory slot="icon">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.29289 11.293C3.90237 11.6835 3.90237 12.3167 4.29289 12.7072L11.2929 19.7072L12.7071 18.293L7.41421 13.0001L19 13.0001V11.0001L7.41421 11.0001L12.7071 5.70718L11.2929 4.29297L4.29289 11.293Z"
                  ></path>
                </svg>
              </MarketAccessory>
            </MarketButton>
          ) : (
            // We must include an empty nav slot or else the default 'x' will show
            <div slot="navigation"></div>
          )}
          {showDoneButton && (
            <MarketButton
              rank="primary"
              slot="actions"
              className={classes.navButton}
              onClick={doneButtonAction}
              data-testid={DONE_BUTTON_TEST_ID}
            >
              {t('dashboardModePage.dashboardModeHeader.label.done')}
            </MarketButton>
          )}
        </MarketHeader>
      </div>
      <MarketActivityIndicatorBar
        className={classes.progressBar}
        value={progress}
        max={1}
        data-testid={PROGRESS_BAR_TEST_ID}
      />
    </div>
  );
};

export default DashboardModeHeader;
